import * as T from '../constants/types';

export const setTerrainMode = mode => dispatch => {
    dispatch({ type: T.SET_TERRAIN_MODE, payload: { terrainMode: mode } });
};
